var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 31.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dc2f5c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,0A13,13,0,0,0,17.26,7.52a6.84,6.84,0,0,0-3.9-1.34,7,7,0,0,0-6.93,6.6A9.61,9.61,0,0,0,9.67,31.45H41.1a8.82,8.82,0,0,0,1-17.6c0-.23,0-.46,0-.7A13.17,13.17,0,0,0,29,0Zm0,2A11.13,11.13,0,0,1,40.14,13.15a13.13,13.13,0,0,1-.09,1.38l-.14,1.12H41.1a6.9,6.9,0,0,1,0,13.8H9.67a7.66,7.66,0,0,1-2-15l.76-.21,0-.79c0-.14,0-.21,0-.22A5,5,0,0,1,16.9,9.65l1.1,1.1.54-1.46A11.15,11.15,0,0,1,29,2ZM19,13.45a2,2,0,1,0,2,2A2,2,0,0,0,19,13.45Zm12,0a2,2,0,1,0,2,2A2,2,0,0,0,31,13.45Zm-6,7a13.83,13.83,0,0,0-9.76,4.35,1,1,0,0,0,1.48,1.35s0,0,0,0A11.75,11.75,0,0,1,25,22.45a11.75,11.75,0,0,1,8.24,3.66,1,1,0,1,0,1.55-1.27l0,0A13.83,13.83,0,0,0,25,20.45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudError);
export default __webpack_public_path__ + "static/media/cloud-error.f9f319828f4c209b684583783b6ed61d.svg";
export { ForwardRef as ReactComponent };